"use client";

import { useActionState } from "react";

import { sendContact, type ContactState } from "./actions";

const mono = "font-paw-mono";
const label = `mb-2 block ${mono} text-[11px] tracking-[0.16em] text-(--paw-steel-dim)`;

export function ContactForm({ status }: { status?: string }) {
  const [state, formAction, pending] = useActionState<ContactState, FormData>(
    sendContact,
    null,
  );

  return (
    <div className="border border-(--paw-line-strong) bg-(--paw-panel) p-8.5">
      {status ? (
        <div className="mb-6.5 flex items-center gap-2.5 border border-(--paw-line-strong) bg-(--paw-ink) px-4 py-3">
          <i className="fa-solid fa-check text-(--paw-positive)" aria-hidden="true" />
          <span className="text-sm text-(--paw-paper)">{status}</span>
        </div>
      ) : null}

      <form action={formAction} className="grid gap-5">
        <div>
          <label htmlFor="name" className={label}>
            NAME
          </label>
          <input
            id="name"
            name="name"
            type="text"
            required
            maxLength={120}
            className="paw-field px-3.5 text-sm"
          />
        </div>

        <div>
          <label htmlFor="email" className={label}>
            EMAIL
          </label>
          <input
            id="email"
            name="email"
            type="email"
            required
            maxLength={255}
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
            className="paw-field px-3.5 text-sm"
          />
        </div>

        <div>
          <label htmlFor="message" className={label}>
            MESSAGE
          </label>
          <textarea
            id="message"
            name="message"
            rows={6}
            required
            maxLength={4000}
            className="paw-field h-auto px-3.5 py-3 text-sm"
          />
        </div>

        {state?.error ? (
          <div
            role="alert"
            className={`border border-(--paw-danger) bg-(--paw-danger-wash) px-4 py-3 ${mono} text-[12px] text-(--paw-paper)`}
          >
            {state.error}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={pending}
          className="paw-btn w-full px-4 py-4 text-sm disabled:opacity-60"
        >
          {pending ? "SENDING…" : "SEND MESSAGE"}
        </button>
      </form>
    </div>
  );
}
